import { Navigate } from 'react-router-dom';
import { useChatAuth } from './ChatAuthProvider';
const ChatPrivateRoute = ({ children }) => {
  const { ischatAuthenticated } = useChatAuth();

  if (!ischatAuthenticated) {
    // If not authenticated, redirect to login page
    return <Navigate to="/aichatbot/login" />;
  }

  // If authenticated, render the children (protected route content)
  return children;
};

export default ChatPrivateRoute;
